// Footer.js

import React from 'react';

export default function Footer() {
    // let footerStyle = {
    //     position: "relative",
    //     top: "95vh",
    //     width: "100%"
    // }
    return (
        <footer className="bg-dark text-light py-1" > {/* style={footerStyle} */}
            <p className="text-center">
                Copyright &copy; ReactiveNotes
            </p>
        </footer>
    )
}
